<!-- FX -->
<div class="fx-count" [ngClass]="{'display-none': !fxCountShown}" (click)="skipFxCount()">
  <div class="circle" #fxCircle></div>
  <div class="three" #three>3</div>
  <div class="two" #two>2</div>
  <div class="one" #one>1</div>
  <div class="go" #go>C'est parti&nbsp;!</div>
</div>

<ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content [scrollEvents]="true">

  <page-loader-comp *ngIf="!longLoading &&
  (
    (bufferLocked && !bufferLoaded) ||
    (!bufferLocked && !serie) ||
    (((!bufferLocked && !serie) || (bufferLocked && !bufferLoaded)) && lastSessionId == 0)
  )
  "></page-loader-comp>

  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': true, 'url': blocHeaderBackUrl, navigate: 'root', loading: (!bufferLocked && !serie) || (bufferLocked && !bufferLoaded)}"></bloc-header-comp>

  <!-- BUFFER -->
  <div *ngIf="longLoading || ((serie || (bufferLoaded && bufferLocked) || (!bufferLocked && serie) || (((!bufferLocked && serie) || (bufferLocked && bufferLoaded)) && lastSessionId != 0)))" class="evs-card-ui buffer-container unselectable">
    <!-- <div class="back-button" (click)="goBack()">
      <ion-icon name="chevron-back"></ion-icon> <span>Retour</span>
    </div> -->
    <div class="rounded-header">
      <div *ngIf="!bufferLocked" class="trick-shadow-top">
        <div class="round-background" [ngClass]="{'shimmer': !serie, 'bg-buffer': !!serie}">
          <div *ngIf="!serie" class="content-center flex-column">
            <div [ngClass]="{'wpi-120': !isDesktop, 'wpi-180': isDesktop}" class="border-radius-20 margin-top-20 padding-20 shimmer"></div>
          </div>
          <ng-container *ngIf="!!serie">
            <div *ngIf="!serie?.theme && serieType != 'erreurs'" class="serie-title" [ngClass]="{'margin-top-20': !isDesktop}">
              <span>Série {{ serie?.position + 1 }}</span>
              <span>Série {{ serie?.position + 1 }}</span>
              <p class='discovery' *ngIf="serie?.type === 'Discovery' && questionIndex <= 0">Série découverte</p>
              <p class='discovery' *ngIf="serieType == 'entrainements' && serie?.type !== 'Discovery' && questionIndex <= 0">Série classique</p>
              <p class='discovery' *ngIf="serieType == 'examens' && questionIndex <= 0">Examen blanc</p>
            </div>
            <div *ngIf="!!serie?.theme" class="serie-title" [ngClass]="{'margin-top-20': !isDesktop}">
              <span>{{serie?.theme}}</span>
              <span>{{serie?.theme}}</span>
            </div>
            <div *ngIf="serieType == 'erreurs'" class="serie-title" [ngClass]="{'margin-top-20': !isDesktop}">
              <span>Mes erreurs</span>
              <span>Mes erreurs</span>
            </div>
            <div class="serie-current-question no-caps" *ngIf="serieType == 'erreurs' && questionIndex == 0">
              <span>A corriger : {{serie?.nbQuestions}}</span>
              <span>A corriger : {{serie?.nbQuestions}}</span>
            </div>
            <div class="serie-current-question" *ngIf="questionIndex > 0">
              <span>Question {{questionIndex + 1}}/{{nbAnswersRef}}</span>
              <span>Question {{questionIndex + 1}}/{{nbAnswersRef}}</span>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="(bufferLocked && !bufferLoaded)" class="trick-shadow-top">
        <div class="round-background shimmer content-center">
          <div class="wpe-40 border-radius-4 padding-20 light-shimmer"></div>
        </div>
      </div>
      <div *ngIf="(bufferLocked && bufferLoaded)" class="trick-shadow-top">
        <div>
          <div class="round-background bg-buffer content-center">
            <div *ngIf="serieType == 'entrainements'" class="serie-title" [ngClass]="{'margin-top-40': !isDesktop, 'margin-top-40': isDesktop && !getSerieFailed}">
              <span>Séries simples</span>
              <span>Séries simples</span>
            </div>
            <div *ngIf="serieType == 'examens'" class="serie-title" [ngClass]="{'margin-top-40': !isDesktop, 'margin-top-40': isDesktop && !getSerieFailed}">
              <span>Examens blancs</span>
              <span>Examens blancs</span>
            </div>
            <div *ngIf="serieType == 'thematiques'" class="serie-title" [ngClass]="{'margin-top-40': !isDesktop, 'margin-top-40': isDesktop && !getSerieFailed}">
              <span>Séries thématiques</span>
              <span>Séries thématiques</span>
            </div>
            <div *ngIf="serieType == 'erreurs'" class="serie-title" [ngClass]="{'margin-top-40': !isDesktop, 'margin-top-40': isDesktop && !getSerieFailed}">
              <span>Mes erreurs</span>
              <span>Mes erreurs</span>
            </div>
          </div>
        </div>
      </div>
      <div class="round-container">
        <div class="round-bloc" [ngClass]="{'bg-buffer': (bufferLocked && bufferLoaded) || (!!serie && !bufferLocked), 'shimmer': ((!bufferLoaded && bufferLocked) || (!bufferLocked && !serie))}"></div>
        <div *ngIf="!bufferLocked" class="btn-launch content-center small-clickable" [ngClass]="{'shimmer': !serie, 'bg-btn-launch': !!serie}" (click)="launchSerie()" #roundedBtnLaunch>
          <img *ngIf="!!serie" src="assets/2022/icons/arrow-white.svg" alt="En Voiture Simone">
        </div>
        <div *ngIf="(bufferLocked && bufferLoaded) && !getSerieFailed && !seriesListFailed && !getErrorSessionFailed" class="btn-launch content-center small-clickable" [ngClass]="{'shimmer': !bufferLoaded, 'bg-btn-launch': bufferLoaded}" (click)="unlock()">
          <img src="assets/2022/icons/arrow-white.svg" alt="En Voiture Simone">
        </div>
        <div *ngIf="(bufferLocked && bufferLoaded) && (getSerieFailed || seriesListFailed || getErrorSessionFailed)" class="btn-launch btn-warning content-center" [ngClass]="{'shimmer': !bufferLoaded, 'bg-btn-launch': bufferLoaded}">
          <img src="assets/svg/warning-ico.svg" alt="En Voiture Simone">
        </div>
      </div>
    </div>
    <div class="buffer-content content-center flex-column" *ngIf="((!bufferLocked && !serie) || (bufferLocked && !bufferLoaded)) && lastSessionId == 0">
      <div class="wpe-95 border-radius-6 padding-6 margin-6 shimmer"></div>
      <div class="wpe-95 border-radius-6 padding-6 margin-6 shimmer"></div>
      <div *ngIf="!isDesktop" class="wpe-95 border-radius-6 padding-6 margin-6 shimmer"></div>
      <div *ngIf="!isDesktop" class="wpe-95 border-radius-6 padding-6 margin-6 shimmer"></div>
      <div class="wpe-40 border-radius-6 padding-6 margin-6 shimmer"></div>
    </div>
    <div class="buffer-content" *ngIf="((!serie && getSerieFailed && bufferLocked && bufferLoaded) || (!!serie && !bufferLocked) || (!!serie && bufferLocked && bufferLoaded)) && lastSessionId == 0" [ngClass]="{'error-mobile text-center': serieType === 'erreurs'}">
      <p *ngIf="!getSerieFailed && serieType == 'entrainements' && serie?.type !== 'Discovery'">Au départ il y avait 40 questions, à la fin il n’en restera aucune.<br><br>Prends ton temps, ceci est un entraînement&nbsp;! 😇</p>
      <p *ngIf="!getSerieFailed && serieType == 'entrainements' && serie?.type === 'Discovery' && !customBufferDiscoveryPostRegistration">Stressé à l’idée d’entamer tes révisions du code&nbsp;?<br><br>Embarque en toute tranquillité avec ces séries de 10 questions plus faciles 😎</p>
      <p *ngIf="!getSerieFailed && serieType == 'entrainements' && serie?.type === 'Discovery' && customBufferDiscoveryPostRegistration">Débloque ta réussite "Explorateur".<br><br>Réponds à 10 questions du code de la route&nbsp;!<br>(Promis elles sont faciles)</p>
      <p *ngIf="!getSerieFailed && serieType == 'examens'">Installe-toi confortablement pour ces 40 questions en temps limité.<br><br>C’est comme un examen mais où et quand tu veux&nbsp;! 😉</p>
      <p *ngIf="!getSerieFailed && serieType == 'thematiques'">Tu sais, moi je ne crois pas qu’il y ait de bonnes ou de mauvaises thématiques. Si je devais résumer le code aujourd’hui avec toi, je dirais que c’est avant tout de l’entraînement ✍️</p>
      <ng-container *ngIf="bufferLoaded && !getSerieFailed && !getErrorSessionFailed && serieType == 'erreurs'">
        <p>Nous avons collecté les erreurs de tes entraînements précédents pour te permettre de les corriger. Prêt à remettre le compteur à zéro&nbsp;?</p>
        <button *ngIf="serie?.nbQuestions > 0 && !userLifeCycle.isUserGuest" class="btn light" [ngClass]="{'margin-top-16': isDesktop, 'white': !isDesktop}" (click)="showModalResetErrors()">Réinitialiser mon compteur</button>
      </ng-container>
      <div *ngIf="getSerieFailed || (getErrorSessionFailed && serieType == 'erreurs')" class="text-center">
        <h4>Ce contenu est indisponible pour le moment</h4>
        <p>Une erreur est survenue sur notre service.<br>Réessaie plus tard.</p>
      </div>
      
      <p class="display-none no-sound-disclaimer"><b>A noter :</b> Nous constatons des problèmes dans le déclenchement du son sur certains navigateurs. Si tu constates cette erreur, nous te conseillons de télécharger Google Chrome ou Mozilla Firefox.</p>
    </div>
    <div class="buffer-content buffer-stats" *ngIf="lastSessionId != 0">
      <div *ngFor="let stat of serieStats" class="space-between padding-bottom-5">
        <span>{{stat.title}}</span>        
        <b>{{stat.stat}}<span>{{stat.text}}</span></b>
      </div>
      <div class="margin-top-30">
        <button type="button" class="btn light center margin-top-30" [ngClass]="{'white': !isDesktop}" (click)="showLastResults()">Dernier résultat</button>
      </div>
    </div>
    <div class="text-right margin-10" *ngIf="authDownload && isCordova && serieType == 'erreurs' && isDesktop">
      Rendre disponible hors ligne <div class="toggle margin-left-10"><input id="erreursToggle" type="checkbox" value="1"/><label for="erreursToggle"></label></div>
    </div>
  </div>
  <div *ngIf="(longLoading || ((serie || (bufferLoaded && bufferLocked) || (!bufferLocked && serie) || (((!bufferLocked && serie) || (bufferLocked && bufferLoaded)) && lastSessionId != 0)))) && (authDownload && isCordova && serieType == 'erreurs' && !isDesktop)" class="text-right margin-10 position-absolute bottom-10 right-10">
    Rendre disponible hors ligne <div class="toggle margin-left-10"><input id="erreursToggle" type="checkbox" value="1"/><label for="erreursToggle"></label></div>
  </div>

  <modal-comp [compOptions]="{'id': 'customModalSerieError', closable: false}" *ngIf="displayModalSerieError" (canClose)="hideModalSerieError()" #modalSerieError>
    <div class="padding-10 text-center">
      <h3>Oops&nbsp;!</h3>
      <p>Une erreur est survenue, réessaie plus tard.</p>
      <button class="btn full-width" (click)="callHideModalNoErrors()">J'ai compris</button>
    </div>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalResetErrors', closable: false}" *ngIf="displayModalResetErrors" (canClose)="hideModalResetErrors()">
    <div class="text-center">
      <h3 *ngIf="isDesktop" class="margin-bottom-20">Souhaites-tu réinitialiser tes erreurs&nbsp;?</h3>
      <h4 *ngIf="!isDesktop" class="margin-bottom-20">Souhaites-tu réinitialiser tes erreurs&nbsp;?</h4>
      <p>Ton compteur d'erreurs sera remis à zéro.</p>
      <button (click)="hideModalResetErrors()" class="btn btn-oui-non light wpi-60 display-inline margin-right-8">Non</button>
      <button (click)="resetErrors()" class="btn btn-oui-non wpi-60 display-inline">Oui</button>
    </div>
  </modal-comp>

</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>